<template>
    <div>
        <CRow>
            <CCol sm="12" xl="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2 mr-2">
                    Filter
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>Filter Options</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.id.val" :description="form.id.inv" label="ID" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.username.val" :description="form.username.inv" label="E-mail" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.first_name.val" :description="form.first_name.inv" label="Fitst Name" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.last_name.val" :description="form.last_name.inv" label="Last Name" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="State"
                                        :options="[
                                            {value: 'true', label:'Active'},
                                            {value: 'false', label:'Inactive'},
                                        ]"
                                        placeholder="Please Select"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_guest.val"
                                        :description="form.is_guest.inv"
                                        label="Guest User"
                                        :options="[
                                            {value: 'true', label:'Yes'},
                                            {value: 'false', label:'No'},
                                        ]"
                                        placeholder="Please Select"
                                        @change="form.is_guest.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <label>Created at</label>
                                    <date-picker placeholder="Please Select" locale="en" v-model="form.created_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at.inv}}</small>
                                </CCol>   
                                <CCol sm="3">
                                    <label>Last Login</label>
                                    <date-picker placeholder="Please Select" locale="en" v-model="form.last_login.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.last_login.inv}}</small>
                                </CCol>               
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;count();get();" color="primary" class="mr-2">Filter</CButton>
                                <CButton @click="remove_filter" color="danger" class="">Remove Filter</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol sm="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>Users</strong>
                        <div class="card-header-actions">
                            Number of All Rows: {{row_count}}
                        </div>
                        </CCardHeader>
                    <CCardBody>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'No items to show.' }">
                            <template #is_active="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.is_active)">
                                        {{data.item.is_active}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #is_guest="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.is_guest)">
                                        {{data.item.is_guest}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #action="data">
                                <td>
                                    <template>
                                    <div class="flex-container">
                                        <div @click="redirect_to(`/profile/${data.item.id}`)"
                                            v-c-tooltip.hover="'profile'">
                                        <CIcon height="20" :content="$options.profile"/>
                                        </div>
                                        <div v-show="$store.state.perm['system.User'].put"
                                            @click="redirect_to(`/user/${data.item.id}/update`)"
                                            v-c-tooltip.hover="'Update'">
                                        <CIcon height="20" :content="$options.update"/>
                                        </div>
                                        <div v-show="$store.state.perm['system.User'].delete"
                                            @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'Delete'">
                                        <CIcon height="20" :content="$options.delete"/>
                                        </div>
                                    </div>
                                    </template>
                                </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="Alert"
            size="sm"
            color="danger"
            :show.sync="delete_modal"
            >
            <p>Are you sure?</p>
            <template #footer>
                <CButton @click="delete_modal=false" color="secondary">No</CButton>
                <CButton @click="delete_row" color="danger">Yes</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { cilUser, cilPencil, cilTrash } from '@coreui/icons'
export default {
    profile: cilUser, update: cilPencil, delete: cilTrash,
    data () {
        return {
            date: '',
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'ID' },
                { key: 'username', label: 'E-mail' },
                { key: 'first_name', label: 'First Name' },
                { key: 'last_name', label: 'Last Name' },
                { key: 'is_active', label: 'State' },
                { key: 'is_guest', label: 'Guest User' },
                { key: 'action', label: 'Action' },
            ],
            collapse: false,
            filter: false,
            form: {
                id: {val: '', inv: '', v: { max: 1024 }},
                username: {val: '', inv: '', v: { max: 1024 }},
                first_name: {val: '', inv: '', v: { max: 1024 }},
                last_name: {val: '', inv: '', v: { max: 1024 }},
                is_active: {val: '', inv: '', v: { max: 1024 }},
                is_guest: {val: '', inv: '', v: { max: 1024 }},
                created_at: {val: '', inv: '', v: { max: 1024 }},
                last_login: {val: '', inv: '', v: { max: 1024 }},
            },
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            delete_modal: false,
            id: 0,
        }
    },
    watch: {
        page: {
            handler(){
                this.count();
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
    },
    mounted(){
        this.count();
        this.get();
    },
    methods: {
        validator() {
            for (const key in this.form) {
                this.form[key].inv = '';
            }
            this.disable = false;
            for (const key in this.form) {
                for (const k in this.form[key].v) {
                    switch (k) {
                        case 'req':
                            if (this.form[key].val == '') {
                                this.form[key].inv = 'This field is required.';
                                this.disable = true;
                            }
                            break;
                        case 'max':
                            if (this.form[key].val != '') {
                                if (this.form[key].val.length > this.form[key].v[k]) {
                                    this.form[key].inv = `Must be a maximum of ${this.form[key].v[k]} characters.`;
                                    this.disable = true;
                                }
                            }
                            break;
                    }
                }
            }
        },
        count() {
            if(this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
                this.axios.get('system/users/?count=1' + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > 100){
                            this.page_count = Math.ceil(res.data.count / 100);
                        } else {
                            this.page_count = 1;
                        }
                    })
            }
        },
        get() {
            if (this.disable == false) {
                this.offset = 0;
                if(this.page != 1){
                    this.offset = (this.page * 100) - 99;
                }
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
                this.axios.get('system/users/' 
                    + '?limit=100' 
                    + '&offset=' + this.offset
                    + filter)
                    .then(res => {
                        res.data.map(val => {
                            switch(val.is_active){
                                case true:
                                    val.is_active = 'Active';
                                    break;
                                case false:
                                    val.is_active = 'Inactive';
                                    break;
                            }
                            switch(val.is_guest){
                                case true:
                                    val.is_guest = 'Yes';
                                    break;
                                case false:
                                    val.is_guest = 'No';
                                    break;
                            }
                            switch(val.sex){
                                case 1:
                                    val.sex = 'Male';
                                    break;
                                case 2:
                                    val.sex = 'Female';
                                    break;
                                case 3:
                                    val.sex = 'Other';
                                    break;
                            }
                        });
                        this.items = res.data;
                    })
            }
        },
        delete_row() {
			this.axios.delete('system/users/'
			+ '?id=' + this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'Deleted Successfully.'
                });
				this.delete_modal = false;
                this.count();
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'Error! please try again.'
                });
                this.delete_modal = false;
			})
        },
        redirect_to(route) {
            this.$router.push(route);
        },
        get_badge(status) {
            switch (status) {
                case 'Active': return 'success'
                case 'Inactive': return 'danger'
                default: return 'secondary'
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.count();
            this.get();
        },
    },
}
</script>
